<template>
  <div  class="item-box">
     <span v-if="item.IsBottom === 0" class="bottom-item">
       {{item.IndustryDesc}}
     </span>
    <span v-if="item.IsBottom === 1">
      <span class="btns" >
        <span><b-form-checkbox class="custom-control-inline" v-model = "isAdd" :disabled="isOmit" data-test="demo-businessType-search-add"/></span>
        <span><b-form-checkbox class="custom-control-inline" v-model = "isOmit"  :disabled="isAdd" data-test="demo-businessType-search-omit"/></span>
      </span>
      <span> {{item.IndustryCode}}:{{item.IndustryDesc}}</span>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object
      },
      deep: {
        type: Number,
        default: 0
      },
      parentItem: {
        type: Object
      },
    },
    data () {
      return {
        isExpand: false,
        thisDeep: 0
      }
    },
    computed: {
      listType () {
        if (this.$store.state.order.ListType) {
          return this.$store.state.order.ListType
        } else {
          return 10
        }
      },
      values () {
        if (this.item.val) {
          return this.item.val
        } else {
          return []
        }
      },
      isClose () {
        return this.item.state === ''
      },
      isBtns () {
        return this.deep !== 0
      },
      isAdd: {
        get () {
          return this.$store.getters['order/isDemoBusinessTypeAdd'](this.item.IndustryCode)
        },
        set (val) {
          if (val === this.isAdd) {
            return
          }
          this.$store.dispatch('order/toggleAddDemoBusinessType', {
            val,
            parentItem: this.parentItem,
            industryCode: this.item.IndustryCode,
            IndustryDesc: this.item.IndustryCode + ':' + this.item.IndustryDesc
          })
        }
      },
      isOmit: {
        get () {
          return this.$store.getters['order/isDemoBusinessTypeOmit'](this.item.IndustryCode)
        },
        set (val) {
          if (val === this.isOmit) {
            return
          }
          this.$store.dispatch('order/toggleOmitDemoBusinessType', {
            val,
            parentItem: this.parentItem,
            industryCode: this.item.IndustryCode,
            IndustryDesc: this.item.IndustryCode + ':' + this.item.IndustryDesc
          })
        }
      }
    },
    mounted () {
      this.thisDeep = this.deep + 1
    },
    methods: {
      select () {
        if (this.isExpand) {
          this.isExpand = false
        } else if (!this.isExpand) {
          this.isExpand = true
          this.expand()
        }
      },
      shrink () {
        this.isExpand = false
      },
      expand () {
        this.isExpand = true
        if (this.values.length > 0) {
          return
        }
        this.$http.post('PlaceOrder.aspx/GetChildrenBySICCode', {
          id: this.item.attributes.IndustryCode,
          listType: this.listType
        }).then(resp => {
          let val = resp.body.d.DataSource
          for (let i = 0; i < val.length; i++) {
            let datas = val[i].data.split('\n')
            val[i].data = datas[0]
          }
          this.$set(this.item, 'val', val)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .bottom-item {
    margin-left: 8px;
    color: #ccc /* TODO@PONY need regular color */
  }
  .item-box {
    /*margin-left: 16px;*/
    position: relative;
    display: block;
  }
  .item-btn {
    padding-right: 16px;
    padding-left: 16px;
  }
  .icon-close {
    margin-left: 64px;
  }
  .item {
    margin-bottom: 16px;
  }
  .btns {
    margin-left: 16px;
    padding-top: 4px;
  }
  .btns-block {
    display: inline-block;
    width: 96px;
  }
  .custom-checkbox {
    min-height: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/BusinessTypeSearchItem.vue